<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-12">
        <button
          aria-controls="project"
          aria-expanded="false"
          class="btn btn-block text-gray_60 border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
          data-target="#project" data-toggle="collapse" role="button">
                    <span class="col-auto pr-3">
                        <svg class="icon m-0">
                            <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                 xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                        </svg>
                    </span>
          <span class="col-auto">{{ __("lang.kwl.overview.project_user") }}</span>
        </button>
        <div id="project" class="collapse">
          <ProjectData></ProjectData>
        </div>
        <div id="accordionOverview" class="accordion">
          <div v-for="(unit, index) in units" v-if="unit.rooms.length > 0" :key="index"
               class="row mb-2 align-items-center">
            <div class="col-auto pr-0">
              <button :aria-controls="'unit_' + index"
                      :data-target="'#unit_' + index" :disabled="unit.rooms.length <= 0" aria-expanded="false"
                      class="btn btn-block d-flex align-items-center text-left no-gutters collapsed"
                      data-toggle="collapse" role="button">
                <!-- :class="+parseFloat(unit.space).toFixed(2) > +parseFloat(roomTotalSpace[index]).toFixed(2) ? 'disabled' : ''" :disabled="parseFloat(unit.space).toFixed(1) > parseFloat(roomTotalSpace[index]).toFixed(1)" -->
                <span class="col-auto pr-3">
                                    <svg class="icon m-0">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </span>
                <span v-if="building.type != 0"
                >{{ unit.name }}, {{ room_floor_options[unit.storey].text }} {{
                    unit.level
                  }}, {{ __("lang.kwl.room_overview.total_space") }}:
                                    {{ +parseFloat(unit.space).toFixed(2) }}
                                    {{ __("lang.kwl.room_overview.square_meter") }}</span
                >
                <span v-else
                >{{ unit.name }}, {{ __("lang.kwl.room_overview.total_space") }}:
                                    {{ +parseFloat(unit.space).toFixed(2) }}
                                    {{ __("lang.kwl.room_overview.square_meter") }}</span
                >
              </button>
            </div>
            <span v-if="+parseFloat(unit.space).toFixed(2) > +parseFloat(roomTotalSpace[index]).toFixed(2)"
                  class="col-auto pl-0">
                            <a v-b-popover.hover.right="__('lang.kwl.room_overview.space_info')" role="button"
                               tabindex="0">
                                <svg class="icon m-0 mb-1 text-primary">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </span>
            <hr class="w-100 my-0 mx-3"/>
            <div :id="'unit_' + index" :class="index == 0 ? 'show' : ''" class="collapse w-100"
                 data-parent="#accordionOverview">
              <div class="container-fluid">
                <div class="row justify-content-end">
                  <div class="col-12 pl-5 pr-0 mt-4">
                    <button
                      aria-controls="building"
                      aria-expanded="false"
                      class="btn btn-block text-gray_60 border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
                      data-target="#building" data-toggle="collapse"
                      role="button">
                                            <span class="col-auto pr-3">
                                                <svg class="icon m-0">
                                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                </svg>
                                            </span>
                      <span class="col-auto">{{ __("lang.kwl.overview.building_data") }}</span>
                    </button>
                    <div id="building" class="collapse">
                      <BuildingData :id="unit.id" :index="index"></BuildingData>
                    </div>
                    <button
                      aria-controls="airflow"
                      aria-expanded="false"
                      class="btn btn-block text-gray_60 border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
                      data-target="#airflow" data-toggle="collapse"
                      role="button">
                                            <span class="col-auto pr-3">
                                                <svg class="icon m-0">
                                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                </svg>
                                            </span>
                      <span class="col-auto">{{ __("lang.kwl.overview.airvolumes") }}</span>
                    </button>
                    <div id="airflow" class="collapse">
                      <UnitAirVolumes :id="unit.id" :index="index"></UnitAirVolumes>
                    </div>
                    <button
                      :aria-controls="'airdistribution_' + index"
                      :data-target="'#airdistribution_' + index"
                      aria-expanded="false"
                      class="btn btn-block text-gray_60 border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
                      data-toggle="collapse"
                      role="button">
                                            <span class="col-auto pr-3">
                                                <svg class="icon m-0">
                                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                </svg>
                                            </span>
                      <span class="col-auto">{{ __("lang.kwl.overview.line_scheme") }}</span>
                    </button>
                    <div style="width: 100%; height: auto">
                      <div :id="'airdistribution_' + index" :ref="'airdistribution_' + index" class="collapse"
                           v-html="svgs[index]"></div>
                    </div>
                    <button
                      v-if="unit.ventilationMeasure == 5 || unit.ventilationMeasure == 6"
                      :aria-controls="'combo_airdistribution_' + index"
                      :data-target="'#combo_airdistribution_' + index"
                      aria-expanded="false"
                      class="btn btn-block text-gray_60 border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
                      data-toggle="collapse"
                      role="button">
                                            <span class="col-auto pr-3">
                                                <svg class="icon m-0">
                                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                </svg>
                                            </span>
                      <span class="col-auto">{{ __("lang.kwl.overview.airflow_technical") }}</span>
                    </button>
                    <div
                      v-if="(unit.ventilationMeasure == 5 || unit.ventilationMeasure == 6) && (controllingSvgs[index] && controllingSvgs[index].length > 0)"
                      :id="'combo_airdistribution_' + index"
                      :ref="'combo_airdistribution_' + index"
                      class="collapse"
                      style="width: 100%; height: auto;"
                    >
                      <div v-for="(combo, key) in controllingSvgs[index]"
                           v-if="controllingSvgs[index] && controllingSvgs[index].length > 0">
                        <div style="width: 100%; height: auto; overflow: scroll" v-html="combo"></div>
                        <div v-if="key != controllingSvgs[index].length - 1">
                          <hr class="w-100 my-0 mx-3"/>
                        </div>
                      </div>
                    </div>
                    <button
                      aria-controls="materials"
                      aria-expanded="false"
                      class="btn btn-block text-gray_60 border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
                      data-target="#materials" data-toggle="collapse"
                      role="button">
                                            <span class="col-auto pr-3">
                                                <svg class="icon m-0">
                                                    <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                                </svg>
                                            </span>
                      <span class="col-auto">{{ __("lang.kwl.overview.materiallist") }}</span>
                    </button>
                    <div id="materials" class="collapse">
                      <MaterialList :index="index" :unitId="unit.id"></MaterialList>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Building from "@models/building/Building";
import Unit from "@models/building/Unit";

import ProjectData from "./ProjectDataComponent";
import BuildingData from "./BuildingDataComponent";
import UnitAirVolumes from "./UnitAirVolumesComponent";
import MaterialList from "./MaterialListComponent";

import {setLabels} from "@services/helpers/langHandler";
import {getSvg, getControllingSvg} from "@services/helpers/svgHandler";
import StoredRoomArticle from "@models/articles/StoredRoomArticle";
import StoredArticle from "@models/articles/StoredArticle";
import axios from "@services/api/axiosConfig";
import ArticlesHasAccessorygroup from "@models/helpers/ArticlesHasAccessorygroup";

export default {
  components: {
    ProjectData,
    BuildingData,
    UnitAirVolumes,
    MaterialList,
  },
  data() {
    return {
      svgs: [],
      controllingSvgs: [],
      roomTotalSpace: [],
    };
  },

  methods: {
    setLabels: setLabels,
    getSvg: getSvg,
    getControllingSvg: getControllingSvg,

    async loadSvg() {
      const units = Unit.query().with(['rooms.airvolume', 'systemselection', 'installation', 'rooms.valves']).get()
      const building = Building.query().first();
      units.forEach(unit => {
        unit.rooms.forEach(room => {
          const devices = StoredRoomArticle.query().where('room_id', room.id).where('accessorygroup_id', 1).get()
          room.deviceAmount = 0
          devices.forEach(device => {
            room.deviceAmount += parseInt(device.quantity)
          })
          room.em = false
          // check if article with id 334 is set in room
          const em = StoredRoomArticle.query().where('room_id', room.id).where('article_id', 334).first()
          if (em) {
            room.em = true
          }

          // if unit ltm decentral check if room has KWL EC 45, ELS or M1 Devices
          if (unit.ventilationMeasure == 5 || unit.ventilationMeasure == 6) {
            // check for KWL EC 45
            const ec45 = StoredRoomArticle.query().whereIdIn([[727, room.id, 1]]).where('quantity', (quantity) => quantity >= 1).get()

            // check for EC 60 (817, 820)
            const ec60 = StoredRoomArticle.query().whereIdIn([[817, room.id, 1], [820, room.id, 1]]).where('quantity', (quantity) => quantity >= 1).get()

            // check for EC 60 Eco(816)
            const ec60Eco = StoredRoomArticle.query().whereIdIn([[816, room.id, 1]]).where('quantity', (quantity) => quantity >= 1).get()

            // check for ELS and M1
            let accessorygroupArticles = ArticlesHasAccessorygroup.query().where('accessorygroups_id', (id) => [42, 43, 44].includes(id)).get();
            const els = StoredRoomArticle.query().where('room_id', room.id).where('accessorygroup_id', 1).where('article_id', (id) => accessorygroupArticles.some(article => article.articles_id == id)).where('quantity', (quantity) => quantity >= 1).get()
            accessorygroupArticles = ArticlesHasAccessorygroup.query().where('accessorygroups_id', 45).get()
            const m1 = StoredRoomArticle.query().where('room_id', room.id).where('accessorygroup_id', 1).where('article_id', (id) => accessorygroupArticles.some(article => article.articles_id == id)).where('quantity', (quantity) => quantity >= 1).get()
            if (ec45) {
              room.ec45 = 0
              ec45.forEach(ec => {
                room.ec45 += parseInt(ec.quantity)
              })
            }
            if (ec60) {
              room.ec60 = 0
              ec60.forEach(ec => {
                room.ec60 += parseInt(ec.quantity)
              })
            }
            if (ec60Eco) {
              room.ec60Eco = 0
              ec60Eco.forEach(ec => {
                room.ec60Eco += parseInt(ec.quantity)
              })
            }
            if (els) {
              room.els = 0
              els.forEach(el => {
                room.els += parseInt(el.quantity)
              })
            }
            if (m1) {
              room.m1 = 0
              m1.forEach(m => {
                room.m1 += parseInt(m.quantity)
              })
            }
          }
        })
        // if unit ltm decentral check if unit has snus (article_id 329, 331) or has snhs (article_id 326, 330)
        if (unit.ventilationMeasure == 5 || unit.ventilationMeasure == 6) {
          const snus = StoredArticle.query().where('unit_id', unit.id).where('article_id', (id) => [329, 331].includes(id)).get()
          const snhs = StoredArticle.query().where('unit_id', unit.id).where('article_id', (id) => [326, 330].includes(id)).get()

          unit.snus = 0
          snus.forEach(snu => {
            unit.snus += parseInt(snu.quantity)
          })

          unit.snhs = 0
          snhs.forEach(snh => {
            unit.snhs += parseInt(snh.quantity)
          })
        }
      })

      // axios post request to /diagram
      axios.post('/diagram', {
        units: units,
        building: building
      }).then(response => {
        this.svgStore = [];
        this.controllingSvgsStore = [];
        this.svgs = response.data.svgBuildings;
        this.controllingSvgs = response.data.decentralSvgs;
        this.svgs.forEach((svg) => {
          this.svgStore.push(this.b64EncodeUnicode(svg));
        });
        if (this.controllingSvgs.length > 0) {
          this.controllingSvgs.forEach((controllingCombo) => {
            if (!controllingCombo || controllingCombo.length <= 0) return
            const controllingComboSVGs = []
            controllingCombo.forEach((svg) => {
              controllingComboSVGs.push(this.b64EncodeUnicode(svg));
            })
            this.controllingSvgsStore.push(controllingComboSVGs)
          });
        }
      })
        .catch(error => {
          console.log(error)
        })

      /*            const response = await getSvg(this.units);

                  this.svgs = response.data;

                  this.svgStore = [];
                  this.svgs.forEach((svg) => {
                      this.svgStore.push(this.b64EncodeUnicode(svg));
                  });*/
    },

    b64EncodeUnicode(str) {
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
          return String.fromCharCode("0x" + p1);
        })
      );
    },
    roomSpace() {
      var array = [];
      this.units.forEach(function (unit) {
        var space = 0;
        unit.rooms.forEach(function (room) {
          if (room.space != null) {
            space = space + parseFloat(room.space);
          }
        });
        array.push(space);
      });
      this.roomTotalSpace = array;
    },
    setInputLabels: function (value) {
      value.forEach(
        function (item) {
          if (item.hasOwnProperty("text")) {
            item.text = this.__(item.text);
          }
          if (item.hasOwnProperty("label")) {
            item.label = this.__(item.label);
          }
        }.bind(this)
      );
      return value;
    },
  },
  computed: {
    units() {
      return Unit.query().withAllRecursive().get();
    },
    building() {
      return Building.query().first();
    },
    room_floor_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.floors);
      },
    },
    svgStore: {
      get() {
        return this.$store.state.svg.svgs;
      },
      set(value) {
        this.$store.commit("svg/updateSvgs", value);
      },
    },
    controllingSvgsStore: {
      get() {
        return this.$store.state.svg.controllingSvgs;
      },
      set(value) {
        this.$store.commit("svg/updateControllingSvgs", value);
      },
    },
  },
  created() {
    this.roomSpace();
    this.loadSvg();
  },
  mounted() {
    window.scrollTo(0, 0);
    document.getElementsByTagName("body")[0].classList.remove("is-loading");
  },
};
</script>
